var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"section",attrs:{"id":"social"}},[_c('div',{staticClass:"container-desktop pad-l"},[_c('h2',{staticClass:"section-title"}),_c('div',{staticClass:"instagram-feed"},_vm._l((_vm.feed.slice(0, _vm.numMedia)),function(data,i){return _c('InstagramCard',{key:i,attrs:{"data":data}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }